// extracted by mini-css-extract-plugin
export default {"zoomModal":"U3-z"};